import React from 'react'

import Layout from '../layouts/layout'
import SEO from '../components/seo'
import TitleHeader from '../components/titleheader'
import SecondaryNav from '../components/secondarynav'
import BorderedBox from '../components/borderedbox'
import MBSeniorLeadership from '../components/mbsenior-leadership'
import headerimage from '../assets/images/whoweare/Corprate_WhoWeAre_BoardofDirectors-A_03.gif'
import mbheaderimage from '../assets/images/whoweare/Corprate_WhoWeAre_BoardofDirectors-MB-A.gif'
import tileimage1 from '../assets/images/whoweare/Muhammad_Umair.jpg'
import asifSeemab from '../assets/images/whoweare/Asif_Seemab.jpg';
import tileimage1451 from '../assets/images/whoweare/PHIL_ENDE_BW_web.jpg'
import tileimage1452 from '../assets/images/whoweare/Kristin_Clifford_Digital_BW.jpg'
import tileimage1453 from '../assets/images/whoweare/Smeeta_Khetarpaul_BW.jpg'
import tileimage61 from '../assets/images/whoweare/John_Szczepanski.jpg'
import tileimage14534 from '../assets/images/whoweare/rajendra.jpg'
import tileimage145345 from '../assets/images/whoweare/tiffany.jpg'
import tileimage1453456 from '../assets/images/whoweare/KG_Headshot_turtleneck_BW.jpg'
import tileimage14534567 from '../assets/images/whoweare/ALEXK_BW.jpg'
import kimRoy from '../assets/images/whoweare/KIM_ROY_WEB_BW_2.jpg'
import lisaPillette from '../assets/images/whoweare/LISA_P_WEB_BW.jpg'
import kimKetch from '../assets/images/whoweare/KIM_KETCH_WEB_BW.jpg'
import kenli from '../assets/images/whoweare/Kenneth Li_015_WEB_BW.jpg'
import ericwarner from '../assets/images/whoweare/TCP_EXEC_ERIC_WAGNER_BW_WEB.jpg'



import { trackPageData, getPageDetails } from '../analytics'

class SeniorLeadership extends React.PureComponent {
  constructor(props) {
    super(props)

    let dataManager = {
      pageDetails: {},
    }
    if (typeof window !== `undefined`) {
      if (window.dataManager) {
        dataManager = window.dataManager
      }
    }
    dataManager.pageDetails = getPageDetails()
  }

  componentDidMount() {
    trackPageData()
  }

  render() {
    return (
      <Layout>
        <SEO title="Senior Leadership | The Children's Place Corporate Website" description="Learn more about The Children's Place Senior Leadership team on The Children's Place Corporate Website." /> {/* Page Title & Header Image */} <div class="row mb-3">
          <div class="col-12">
            <TitleHeader image={headerimage} mbheaderimage={mbheaderimage} title="WHO WE ARE" />
          </div>
        </div> {/* End Page Title & Header Image */}
        <SecondaryNav active="Senior Leadership" name1="About Us" link1="/about-us" name2="Senior Leadership" link2="/senior-leadership" name3="Board of Directors" link3="/board-of-directors" name4="International Franchises" link4="/international-franchises" />
        <div class="row mb-5 d-md-flex">
          <div class="col-12">
            <h4> TURKI SALEH A. ALRAJHI{' '} <i class="text-muted base-font dark" style={{fontSize: `12px`}}>(not pictured)</i>
              <span class="text-muted base-font dark">
                <br /> Executive Chairman </span>
            </h4>
            <p> Mr. AlRajhi serves as the Executive Chairman of the Board of the Company. He is also the Chairman and Chief Executive Officer of Mithaq Holding Company and Managing Director of Mithaq Capital SPC. In these roles, he is responsible for drafting and executing the overall strategy, which includes making the capital allocation decisions and the selection and compensation of senior executives. Mr. AlRajhi holds a Bachelor of Finance and Banking from Dar Al Uloom University in the Kingdom of Saudi Arabia and completed the Value Investing Program from Columbia Business School in the United States of America. He aspires to master Chapters 8 and 20 of Prof. Benjamin Graham’s “The Intelligent Investor.” </p>
          </div>
        </div>
        <div class="row mb-5 d-none d-md-flex">
          <div class="col-3 fill">
            <img src={asifSeemab} className="img-fluid" alt="" />
          </div>
          <div class="col-9 border-bottom">
            <h4> MUHAMMAD ASIF SEEMAB{' '} <span class="text-muted base-font dark"> | Executive Vice Chairman </span>
            </h4>
            <p> Mr. Seemab serves as the Executive Vice Chairman of the Board of the Company and the Chair of the Human Capital and Compensation Committee. He also serves as Managing Director of Mithaq Holding Company and Mithaq Capital SPC, where he is responsible for executing and managing the company's investments, which include public equity, private equity, real estate, and income-producing assets in local and international markets. Mr. Seemab holds a Bachelor of Commerce from Hailey College of Commerce at the University of the Punjab and is a Chartered Accountant and an associate member of The Institute of Chartered Accountants of Pakistan. </p>
          </div>
        </div>
        <div class="row d-md-none"> {/* <div class="col-12">
            <hr class="border-top pb-1" />
          </div> */} <div class="col-4 fill">
            <img src={asifSeemab} className="img-fluid" alt="" />
          </div>
          <div class="col-8">
            <h4 class="mb-1 mt-4"> MUHAMMAD ASIF SEEMAB</h4>
            <p class="text-muted base-font dark text-large"> Executive Vice Chairman </p>
          </div>
          <div class="col-12 mt-5">
            <p class=" pb-4 border-bottom"> Mr. Seemab serves as the Executive Vice Chairman of the Board of the Company and the Chair of the Human Capital and Compensation Committee. He also serves as Managing Director of Mithaq Holding Company and Mithaq Capital SPC, where he is responsible for executing and managing the company's investments, which include public equity, private equity, real estate, and income-producing assets in local and international markets. Mr. Seemab holds a Bachelor of Commerce from Hailey College of Commerce at the University of the Punjab and is a Chartered Accountant and an associate member of The Institute of Chartered Accountants of Pakistan. </p>
          </div>
        </div>
        <div class="row mb-5 d-none d-md-flex">
          <div class="col-3 fill">
            <img src={tileimage1} className="img-fluid" alt="" />
          </div>
          <div class="col-9">
            <h4> MUHAMMAD UMAIR{' '} <span class="text-muted base-font dark"> | President &amp; Chief Executive Officer </span>
            </h4>
            <p> Mr. Umair serves as the President and Chief Executive Officer of the Company. Prior to his appointment as President and Chief Executive Officer, Mr. Umair was a Senior Advisor for Origin Funding Partners, a global trade finance fund, where he was responsible for credit, recovery, and due diligence. Prior to joining Origin Funding Partners, Mr. Umair held positions in various organizations, including Head of Advisory at Armacom and Senior Auditor at Ernst & Young. He is a Chartered Accountant and associate member of the Institute of Chartered Accountants of Pakistan and the Institute of Chartered Accountants in England and Wales. Mr. Umair has more than 17 years of financial and commercial experience, including investment management, corporate advisory, operational and financial due diligence and audit. </p>
          </div>
        </div>
        <div class="row d-md-none"> {/* <div class="col-12">
            <hr class="border-top pb-1" />
          </div> */} <div class="col-4 fill">
            <img src={tileimage1} className="img-fluid" alt=" " />
          </div>
          <div class="col-8">
            <h4 class="mb-1 mt-4">MUHAMMAD UMAIR</h4>
            <p class="text-muted base-font dark text-large"> President &amp; <br /> Chief Executive Officer </p>
          </div>
          <div class="col-12 mt-5">
            <p class=" pb-4"> Mr. Umair serves as the President and Chief Executive Officer of the Company. Prior to his appointment as President and Chief Executive Officer, Mr. Umair was a Senior Advisor for Origin Funding Partners, a global trade finance fund, where he was responsible for credit, recovery, and due diligence. Prior to joining Origin Funding Partners, Mr. Umair held positions in various organizations, including Head of Advisory at Armacom and Senior Auditor at Ernst &amp; Young. He is a Chartered Accountant and associate member of the Institute of Chartered Accountants of Pakistan and the Institute of Chartered Accountants in England and Wales. Mr. Umair has more than 17 years of financial and commercial experience, including investment management, corporate advisory, operational and financial due diligence and audit. </p>
          </div>
        </div>
        <div class="firstgroup d-none d-md-block" id="seniorleadershipcolapsegroup"> {/* START Content for text Section1 */} <div class="row mb-3 text-center">
        <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="true" aria-controls="collapseExample1">
                <img src={kimRoy} className="img-fluid mb-2" alt="" />
                <h5>KIM ROY</h5>
                <p> Executive Director </p>
              </a>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="true" aria-controls="collapseExample2">
                <img src={tileimage61} className="img-fluid mb-2" alt="" />
                <h5>JOHN SZCZEPANSKI</h5>
                <p> Chief Financial Officer </p>
              </a>
            </div>
        
            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample4" role="button" aria-expanded="true" aria-controls="collapseExample4">
                <img src={lisaPillette} className="img-fluid mb-2" alt="" />
                <h5>LISA PILLETTE</h5>
                <p> Chief Customer Officer </p>
              </a>
            </div>

          </div> {/* END Content for text Section1 */} {/* START Hidden content for dropdown text Section1 */} <div class="row mb-5">
            <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="collapse" id="collapseExample1" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample1" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> KIM ROY <span class="text-muted base-font dark"> {' '} | Executive Director </span>
                    </h5>
                    <p className="text-left"> Kim Roy joined The Children’s Place in 2026 as Executive Director and a member of the Board of Directors. In this role, she serves as a strategic operating leader, supporting President and CEO Muhammad Umair and the executive leadership team, with a focus on providing strategic direction and aligning key front-end functions, including Design, Merchandising, Planning, and Stores. Kim has led and grown several multi-billion-dollar brand portfolios throughout her career. She held leadership roles of increasing responsibility at Ralph Lauren Corporation, culminating in the role of Group President, North America. Previously, she served as President of Ann Taylor, Group President at Liz Claiborne, Inc., and Senior Vice President, General Merchandise Manager at Associated Merchandising Corporation. Kim has served on the Boards of Directors of Chico’s FAS, Inc. and Weight Watchers International, Inc. She is an advisor and former director of Catholic Guardian Services and a graduate of Skidmore College, where she serves as a long-standing Board Trustee. </p>
                  </BorderedBox>
                </div>
              </div>
              <div class="collapse" id="collapseExample2" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample2" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> JOHN SZCZEPANSKI <span class="text-muted base-font dark"> {' '} | Chief Financial Officer </span>
                    </h5>
                    <p className="text-left"> John joined The Children’s Place in 2025 as Chief Financial Officer, overseeing Accounting, Financial Planning & Analysis, Tax, Treasury, Internal Audit, Real Estate, and Investor Relations. In addition, he leads the Supply Chain and Legal organizations, helping drive financial discipline, operational excellence, strong governance, and disciplined execution across key business functions. John brings extensive financial leadership experience across the retail and manufacturing sectors. Prior to joining The Children’s Place, he served as Chief Financial Officer at Vince Holding Corp. Before that, he held significant roles at Ralph Lauren Corporation, where he held leadership roles of increasing responsibility, ultimately serving as Chief Financial Officer for the Global Supply Chain, Brands, and Lifestyle Group. John holds a Master of Science in Finance from Boston College’s Carroll School of Management and a Bachelor of Science in Accounting from Fordham University. </p>
                  </BorderedBox>
                </div>
              </div>
         
              <div class="collapse" id="collapseExample4" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample4" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> LISA PILLETTE <span class="text-muted base-font dark"> {' '} | Chief Customer Officer </span>
                    </h5>
                    <p className="text-left"> Lisa joined The Children’s Place in 2026 as Chief Customer Officer, where she leads the Company’s front-end transformation, overseeing brand strategy, creative direction, and marketing initiatives. She serves on the Senior Leadership Team and reports to President and CEO Muhammad Umair. Lisa brings extensive global marketing and brand leadership experience, having served as Global Chief Marketing Officer at Fossil Group and Chief Marketing Officer at Casper Sleep. She previously held senior marketing roles at Lacoste and Ralph Lauren Corporation, leading brand strategy, marketing, CRM, and analytics initiatives. She is known for driving brand transformation through consumer-focused marketing, digital innovation, and culture-led design. Lisa graduated from the University of Colorado Boulder and serves on several industry boards and advisory councils, including MyCode, the National Association for Business Economics Chicago Chapter, the CMO Council, and TRIPTK. </p>
                  </BorderedBox>
                </div>
              </div>
            </div>
          </div> {/* END Hidden content for dropdown text Section1 */} {/* START Content for text Section2 */} <div class="row mb-3 text-center">
            
            
            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample5" role="button" aria-expanded="false" aria-controls="collapseExample5">
                <img src={tileimage1452} className="img-fluid mb-2" alt="" />
                <h5>KRISTIN CLIFFORD</h5>
                <p> Senior Vice President, <br /> Head of Global Sourcing & Product Operations </p>
              </a>
            </div>
            
             <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample6" role="button" aria-expanded="false" aria-controls="collapseExample6">
                <img src={tileimage1453456} className="img-fluid mb-2" alt="" />
                <h5>KIERA GANANN</h5>
                <p> Senior Vice President, <br /> Head of Merchandising </p>
              </a>
              
            </div>
            {/* <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample7" role="button" aria-expanded="false" aria-controls="collapseExample7">
                <img src={tileimage14534} className="img-fluid mb-2" alt="" />
                <h5>RAJENDRA KARAMCHETI</h5>
                <p> Senior Vice President, <br /> Chief Technology Officer </p>
              </a>
            </div> */}


            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample11" role="button" aria-expanded="false" aria-controls="collapseExample11">
                <img src={tileimage14534567} className="img-fluid mb-2" alt="" />
                <h5>ALEKSANDRA KINNEY</h5>
                <p> Senior Vice President, <br /> Global Planning & Inventory Management </p>
              </a>
            </div>
            

      
          </div> {/* END Content for text Section2 */} {/* START Hidden content for dropdown text Section2 */} <div class="row mb-5">
            <div class="col-lg-12 col-md-12 col-sm-12">
           
              <div class="collapse" id="collapseExample5" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample5" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> KRISTIN CLIFFORD <span class="text-muted base-font dark"> {' '} | Senior Vice President, Head of Global Sourcing & Product Operations </span>
                    </h5>

                    <p className="text-left"> Kristin rejoined The Children’s Place in 2025 as the Senior Vice President, Head of Global Sourcing. Kristin leads sourcing initiatives and manages teams of sourcing professionals in developing costing strategies to meet the company’s financial targets by collaborating with external partners to produce high-quality merchandise that is brand-consistent and competitively priced. Previously, Kristin worked at The Children’s Place from 2013 to 2020, where she held various roles of increasing responsibility, ultimately rising to the position of Vice President of Global Sourcing. Most recently, she served as the Senior Vice President of Sourcing at Vineyard Vines. Additionally, Kristin has held key leadership positions, including Senior Vice President of Global Sourcing at Juicy Couture and Vice President of Corporate Sourcing Operations at Liz Claiborne. She earned her Bachelor of Arts in Business Economics from Belmont Abbey College. </p>
                  </BorderedBox>
                </div>
              </div>
            
            

                <div class="collapse" id="collapseExample6" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample6" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> KIERA GANANN <span class="text-muted base-font dark"> {' '} | Senior Vice President, Head of Merchandising </span>
                    </h5>
                    <p className="text-left"> Kiera joined The Children’s Place in 2025 as the Senior Vice President, Head of Merchandising. In this capacity, she leads merchandising teams across all brands, with a strategic focus on advancing the company’s product vision and achieving excellence in merchandising across channels. Throughout her career, Kiera has effectively managed large teams across merchandising and commercial functions, consistently driving significant revenue growth, fortifying brand integrity, and delivering innovative product solutions aligned with evolving consumer trends. In her previous position, she served as Senior Vice President at Delta Galil, where she was Global General Manager for Ralph Lauren Intimates and Sleepwear. Prior to this, Kiera was the Vice President of Merchandising for North and South America at Levi’s, where she directed merchandising initiatives. Kiera has also held senior leadership roles at Ralph Lauren, overseeing sales and merchandising strategies for both the Men’s and Women’s divisions. She earned her Bachelor of Arts in Journalism/Advertising from the University of Oklahoma.</p>
                  </BorderedBox>
                </div>
              </div>
            </div>

            {/* <div class="collapse" id="collapseExample7" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample7" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> RAJENDRA KARAMCHETI <span class="text-muted base-font dark"> {' '} | Senior Vice President, Chief Technology Officer </span>
                    </h5>
                    <p className="text-left"> Rajendra joined The Children’s Place in 2019 and has taken on roles with increasing responsibility throughout his tenure with TCP. Currently serving as SVP, Chief Technology Officer, Rajendra leads the company’s global technology strategy, overseeing IT, digital infrastructure, and innovative initiatives. He is responsible for driving technology transformation efforts that enhance operational efficiency, promote business growth, and improve the customer experience. Rajendra has played a key role in modernizing the company’s technology platforms, optimizing operations, and aligning digital capabilities with strategic business objectives. He holds a Bachelor’s degree in Computer and Information Science from Andhra University. </p>
                  </BorderedBox>
                </div>
              </div> */}


              <div class="collapse" id="collapseExample11" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample11" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> ALEKSANDRA KINNEY <span class="text-muted base-font dark"> {' '} | Senior Vice President, Global Planning & Inventory Management </span>
                    </h5>
                    <p className="text-left"> Aleksandra joined The Children’s Place in 2018 and has progressively taken on roles with increased responsibility throughout her tenure with the company. Currently, she serves as the Senior Vice President, Head of Global Planning and Inventory. In this role, she leads the planning and inventory teams and plays a crucial part in expanding the company’s wholesale and marketplace partnerships. Aleksandra is responsible for leading transformative initiatives in planning and inventory management that enhance efficiency, support business growth, and improve the customer experience. She has been instrumental in developing long-term inventory strategies and optimizing end-to-end inventory performance to foster greater profitability and operational excellence. Aleksandra holds a Bachelor’s degree from Rutgers University.</p>
                  </BorderedBox>
                </div>
              </div>

          </div> {/* END Hidden content for dropdown text Section2 */} {/* START Content for text Section3 */}
          
          
          
           <div class="row mb-3 text-center">
            
          
            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample9" role="button" aria-expanded="false" aria-controls="collapseExample9">
                <img src={tileimage1451} className="img-fluid mb-2" alt="" />
                <h5>PHILIP ENDE</h5>
                <p> Group Vice President, <br /> Head of Real Estate </p>
              </a>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample10" role="button" aria-expanded="false" aria-controls="collapseExample10">
                <img src={kimKetch} className="img-fluid mb-2" alt="" />
                <h5>KIM KETCH</h5>
                <p> Group Vice President, <br /> Head of Design </p>
              </a>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample12" role="button" aria-expanded="false" aria-controls="collapseExample12">
                <img src={kenli} className="img-fluid mb-2" alt="" />
                <h5>KENNETH LI</h5>
                <p> Group Vice President, <br /> General Counsel and Corporate Secretary </p>
              </a>
            </div>
           
          


       
          </div> {/* END Content for text Section3 */} {/* START Hidden content for dropdown text Section3 */} 
          <div class="row mb-5">
            <div class="col-lg-12 col-md-12 col-sm-12">
              
              <div class="collapse" id="collapseExample9" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample9" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> PHILIP ENDE <span class="text-muted base-font dark"> {' '} | Group Vice President, Head of Real Estate </span>
                    </h5>
                    <p className="text-left"> Philip joined The Children’s Place in 2024 as Group Vice President, Head of Real Estate. Philip leads all real estate strategy and asset management, including acquisition, development, and leasing. Prior to joining, Philip served as President and Founder of Ende Real Estate Advisors, a real estate consulting firm. Prior to that, he worked at Simon Property Group holding roles of increasing responsibility, culminating in his position as Senior Vice President – Leasing Premium Outlets. Philip earned his Bachelor’s Degree from the University of Florida. </p>
                  </BorderedBox>
                </div>
              </div>

              <div class="collapse" id="collapseExample10" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample10" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> KIM KETCH <span class="text-muted base-font dark"> {' '} | Group Vice President, Head of Design </span>
                    </h5>
                    <p className="text-left"> Kim joined The Children’s Place in 2015 and has taken on roles of increasing responsibility throughout her tenure, demonstrating strong leadership and a deep understanding of the brand. As GVP, Head of Design, she leads the end-to-end Design function, overseeing the full creative process from concept development and trend direction through final product execution. She partners closely with Merchandising, Production, and Marketing to bring cohesive, customer-focused assortments to market that support both brand vision and business objectives. In her role, Kim ensures every collection is innovative, commercially viable, and aligned with the company’s strategic priorities, while maintaining a consistent brand aesthetic across categories. Kim holds a bachelor’s degree in Fashion Design from the Fashion Institute of Technology. </p>
                  </BorderedBox>
                </div>
              </div>

              <div class="collapse" id="collapseExample12" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample12" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> KENNETH LI <span class="text-muted base-font dark"> {' '} | Group Vice President, General Counsel and Corporate Secretary </span>
                    </h5>
                    <p className="text-left"> 
                    Kenneth joined The Children’s Place in 2021 and has held roles of increasing responsibility throughout his tenure. As GVP, General Counsel and Corporate Secretary, he oversees TCP’s enterprise legal strategy and corporate administration matters, including the areas of board governance, litigation, intellectual property, real estate, employment, product safety, and enterprise risk. Partnering closely with leaders across the organization, Kenneth plays a key role in ensuring the company operates within sound legal frameworks, upholds effective corporate governance standards, and manages risk to support TCP’s strategic priorities and continued growth. Kenneth earned a Bachelor of Arts in Criminology, Ethics, Society & Law, and Linguistics, as well as his Juris Doctorate, from the University of Toronto.

                    </p>
                  </BorderedBox>
                </div>
              </div>

            
             
            </div>
          </div> 
          
          


{/* new section of GVPs  */}
{/* END Hidden content for dropdown text Section2 */} {/* START Content for text Section3 */}
          
          
          
<div class="row mb-3 text-center">
            
          
           
           
            <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample13" role="button" aria-expanded="false" aria-controls="collapseExample13">
                <img src={ericwarner} className="img-fluid mb-2" alt="" />
                <h5>ERIC WARNER</h5>
                <p> Group Vice President, <br /> Head of Human Resources </p>
              </a>
            </div>
           
       

             <div class="col-lg-3 col-md-6 col-sm-12">
              <a class="btn p-0 " data-toggle="collapse" href="#collapseExample14" role="button" aria-expanded="false" aria-controls="collapseExample14">
                <img src={tileimage145345} className="img-fluid mb-2" alt="" />
                <h5>TIFFANY WHITFORD</h5>
                <p> Group Vice President, <br /> Head of Stores </p>
              </a>
            </div>
          </div> {/* END Content for text Section3 */} {/* START Hidden content for dropdown text Section3 */} 
          <div class="row mb-5">
            <div class="col-lg-12 col-md-12 col-sm-12">
              
           

              <div class="collapse" id="collapseExample13" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample13" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> ERIC WARNER <span class="text-muted base-font dark"> {' '} | Group Vice President, Head of Human Resources </span>
                    </h5>
                    <p className="text-left"> Eric joined The Children's Place in 2022 and has held roles of increasing responsibility throughout his tenure with the organization. As GVP, Head of Human Resources, he leads TCP’s enterprise people strategy, overseeing talent acquisition, total rewards, HR operations, talent management, associate experience, and organizational effectiveness. Partnering closely with leaders across the organization, Eric plays a key role in strengthening the company’s culture, developing high-performing teams, and building the capabilities needed to support TCP’s strategic priorities and continued growth. He holds a Master’s degree in Information Systems and Business Administration from Temple University.</p>
                  </BorderedBox>
                </div>
              </div>
             
        

              <div class="collapse" id="collapseExample14" data-parent="#seniorleadershipcolapsegroup">
                <div class="">
                  <BorderedBox>
                    <button class="btn close-button" type="button" data-toggle="collapse" data-target="#collapseExample14" aria-expanded="false" aria-controls=""> X </button>
                    <h5 className="text-left"> TIFFANY WHITFORD <span class="text-muted base-font dark"> {' '} | Group Vice President, Head of Stores </span>
                    </h5>
                    <p className="text-left"> Tiffany joined The Children’s Place in 2025 as the Group Vice President, Head of Stores, bringing with her a passion for creating exceptional customer experiences. In her role, she oversees store operations and field leadership, prioritizing impactful connections with customers. Prior to this, Tiffany served as Zone Vice President for Sunglass Hut Northeast at EssilorLuxottica and held influential positions at MAC Cosmetics North America and Kate Spade & Company. Tiffany's collaborative and results-driven leadership style is known for strengthening customer relationships and driving impressive growth. She holds a BFA and an AAS in Fashion Buying and Merchandising from the Fashion Institute of Technology. </p>
                  </BorderedBox>
                </div>
              </div>

            </div>
          </div> 
          

{/* end new section of GVPs */}





          
          
          
          {/* END Hidden content for dropdown text Section4 */} </div>
          
          
          
          
          
          <div class="d-md-none">
          <MBSeniorLeadership />
        </div>
      </Layout>
    )
  }
}

export default SeniorLeadership
